const defaultValue = (name, storedData, translatable, dValue = '') => {
  if (typeof storedData[name] !== 'undefined') {
    return storedData[name]
  }
  return translatable ? {} : dValue
}

export default defaultValue